module.exports = __webpack_public_path__ + "img/no-avatar-review.499e4cc8.svg";